// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1V57Y","label":"Labeled_label__3wS-b","divider":"Labeled_divider__17WB_"};